import React from 'react';
import { observer } from 'mobx-react';
import { SentenceBreakdownItemWrapper } from '@seedlang/hoc';
import { pixify } from '@seedlang/utils';
import styled from '@emotion/styled';
import InPlaceTextInput from 'components/form/in_place_text_input';
import { last } from 'lodash';

const Wrapper = styled.span`
  font-size: ${props => props.fontSize};
  line-height: ${props => props.lineHeight};
  margin-right: ${props => props.marginRight};
  margin-left: ${props => props.marginLeft};
  padding: ${props => props.padding};
  cursor: ${props => props.disableOnClick ? 'default' : (props.selectable || props.showUnderline ? 'pointer' : 'default')};
  border-bottom: ${props => props.borderBottom};
  display: inline-flex;
  align-items: center;
  position: relative;
  input {
    text-align: center;
    border-radius: 5px;
    font-size: 18px;
    padding: 4px 5px;
    height: 34px;
    margin: 2px 0;
    border: ${props => props.inputFocused && !props.inputBackground ? '2px solid #333' : '2px solid rgba(255, 255, 255, 0)'};
    background: ${props => props.inputBackground};
    color: ${props => props.inputBackground ? '#fbfbfb' : '#333'};
    cursor: ${props => props.inputBackground ? 'pointer' : 'default'};
  }
`;

const Background = styled.div`
  position: absolute;
  top: 2px;
  left: -8px;
  right: -8px;
  bottom: 2px;
  background: ${props => props.background};
  border-radius: 4px;
  z-index: 0;
`;

const WordText = styled.div`
  z-index: 1;
`;

const FakeTextInput = styled.div`
  background: white;
  border: 2px solid #FFF;
  border-radius: 5px;
  height: 38px;
  width: ${props => props.width};
`;

const GapUnderline = styled.div`
  height: ${props => props.height};
  width: ${props => props.width};
  border-bottom: 2px solid #333;
`;

@observer
class SentenceBreakdownItem extends React.Component {

  render() {
    if (this.props.wordText) {
      return (
        <Wrapper
          padding={`0 ${pixify(this.props.paddingHorizontal)}`}
          marginRight={this.props.wordText && last(this.props.wordText) === '\'' ? '0px' : pixify(this.props.marginRight)}
          marginLeft={this.props.marginLeft}
          fontSize={pixify(this.props.fontSize)}
          lineHeight={pixify(this.props.lineHeight)}
          borderBottom={this.props.borderBottom}
          selectable={this.props.selectable}
          showUnderline={this.props.showUnderline}
          onClick={() => this.props.onClick(this.props.wordAssociation)}
          inputFocused={this.props.inputFocused}
          inputBackground={this.props.inputBackground}
          disableOnClick={this.props.disableOnClick}
        >
          {
            this.props.highlightBackground &&
              <Background background={this.props.highlightBackground} />
          }
          {
            !this.props.textInput && !this.props.showTextInput && !this.props.showGapUnderline && this.props.wordText &&
              <WordText>{this.props.wordText.normalize('NFC')}</WordText>
          }
          {
            this.props.showGapUnderline &&
            <GapUnderline
              height={pixify(this.props.fontSize || 20)}
              width={pixify(this.props.wordText ? this.props.wordText.length * 20 : 70)}
            />
          }
          {
            this.props.textInput && this.props.hideTextInput &&
            <FakeTextInput
              width={pixify(40 + (this.props.inputWordLength * 10))}
            />
          }
          {
            this.props.showTextInput &&
            <InPlaceTextInput
              refs='input'
              style={{
                width: 40 + (this.props.inputWordLength * 10),
              }}
              disabled={this.props.disableInput}
              caretPosition={this.props.wordAssociation?.id === this.props.focusedWordAssociationId ? this.props.caretPosition : null}
              id={this.props.wordAssociation?.id}
              submitOnEnter
              tabIndex={this.props.index + 1}
              onSubmit={this.props.onSubmit}
              readOnly={this.props.inputCorrect || this.props.inputIncorrect}
              value={this.props.inputIncorrect || this.props.inputCorrect ? this.props.wordText : this.props.inputValue}
              onFocus={() => this.props.onInputFocus(this.props.wordAssociation?.id)}
              onChange={val => this.props.onInputChange(val, this.props.wordAssociation?.id)}
              focusOnMount={this.props.inputFocused}
            />
          }
        </Wrapper>
      );
    }
    return <span />;
  }
}

export default SentenceBreakdownItemWrapper(SentenceBreakdownItem);
